// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function RetireTreeIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M10.738 3.589a9.504 9.504 0 0 1 14.024 4.235 9 9 0 1 1-8.759 15.661l-.002-.001-.002-.001h-.002l-.002.002a9.001 9.001 0 0 1-13.954-6.61 9 9 0 0 1 5.196-9.05 9.504 9.504 0 0 1 3.501-4.236ZM16 4a7.504 7.504 0 0 0-6.918 4.599c-.194.46-.553.832-1.007 1.042a7.003 7.003 0 0 0-4.043 7.04 7 7 0 0 0 10.853 5.14l-.002.002a2.004 2.004 0 0 1 2.233 0 7 7 0 1 0 6.81-12.182 2 2 0 0 1-1.008-1.043A7.503 7.503 0 0 0 16 4Z"
						clipRule="evenodd"
					/>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M17 11a1 1 0 1 0-2 0v6.382l-4.553-2.276a1 1 0 1 0-.894 1.788L15 19.618V29a1 1 0 1 0 2 0V16.618l5.447-2.724a1 1 0 1 0-.894-1.788L17 14.382V11Z"
						clipRule="evenodd"
					/>
				</svg>
			}
		</IconContainer>
	);
}
